module.exports = __webpack_public_path__ + "static/media/miniLogo.24edde09.svg";